<template>
  <div :style="brandColors" class="row vehicle-unit">
    <div class="col-xs-12">
      <div class="row">
        <div class="col-sm-4">
          <a class="visible-xs" href="#">
            <h2 class="text-center">
              {{ vehicle.modelName }}
            </h2></a
          >
          <div class="row vehicle-thumb">
            <div class="col-xs-12">
              <div class="vehicle-thumb-container">
                <a class="preview-images" href="#"
                ><img
                    :alt="vehicle.modelName"
                    class="img-responsive lazyloaded"
                    :src="vehicle.angleView"
                /></a>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <div class="srp-window-sticker">
                    <a class="srp-window-sticker-link" href="#"
                      ><i class="fa fa-list-alt"></i
                      ><span>&nbsp;View Vehicle Window Sticker</span></a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-8 vehicle-details">
          <div class="row">
            <div class="col-sm-6 vehicle-specs">
              <div class="row">
                <div class="col-sm-12 hidden-xs">
                  <a href="#"
                    ><h2>{{ vehicle.modelName }}</h2>
                    <h5 class="vdp-link">View Vehicle Details</h5></a
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 vehicle-index-summary">
                  <div class="index-summary-rows">
                    <div class="row stock-number">
                      <div class="col-xs-12">
                        <span>Stock Number:</span
                        ><span class="pull-right">123456</span>
                      </div>
                    </div>
                    <div class="row stock-number">
                      <div class="col-xs-12">
                        <span>VIN:</span
                        ><span class="pull-right">XXXXXXXXXXXXXXX</span>
                      </div>
                    </div>
                  </div>
                  <div class="row model-code">
                    <div class="col-xs-12">
                      <span>Model Code:</span
                      ><span class="pull-right">W12</span>
                    </div>
                  </div>
                  <div class="row engine">
                    <div class="col-xs-12">
                      <span>Engine:</span
                      ><span class="pull-right">0.0 L 0</span>
                    </div>
                  </div>
                  <div class="row drivetrain">
                    <div class="col-xs-12">
                      <span>Drive:</span><span class="pull-right">WD</span>
                    </div>
                  </div>
                  <div class="row transmission">
                    <div class="col-xs-12">
                      <span>Trans:</span
                      ><span class="pull-right">AUTOMATIC W/OD</span>
                    </div>
                  </div>
                  <div class="row mileage">
                    <div class="col-xs-12">
                      <span>Mileage:</span><span class="pull-right">0</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12">
                      <span>Fuel Economy:</span
                      ><span class="pull-right">00/25</span>
                    </div>
                  </div>
                  <div class="row exterior-color">
                    <div class="col-xs-12">
                      <span>Color:</span
                      ><span class="pull-right">EXTERIOR</span>
                    </div>
                  </div>
                  <div class="row interior-color">
                    <div class="col-xs-12">
                      <span>Interior:</span
                      ><span class="pull-right">INTERIOR</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 pricing-wrapper">
              <RowVehiclePricing 
                :isLocked="isLockedPricingSelected"
                :price="price"
              />
              <div v-if="selectedPriceBtn" class="get-price-btn-wrapper">
                <img
                  v-if="!usingFlatButton"
                  class="get-price-btn"
                  :src="!hovering ? selectedPriceBtnImg : selectedPriceBtnHoverImg"
                  @mouseenter="hovering = true"
                  @mouseleave="hovering = false"
                  />
                <a v-else :class="brandButtonClass" class="get-price-flat-btn primary-btn" href="#">{{ flatButtonText }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row col-xs-12 vehicle-index-buttons vehicle-buttons">
      <div class="col-sm-3">
        <a :class="[usingFlatButton || brand === 'cjdr' ? 'secondary-btn' : 'primary-btn', brandButtonClass]" class="btn-1" href="#">Value Your Trade</a>
      </div>
      <div class="col-sm-3">
        <a :class="[usingFlatButton || brand === 'cjdr' ? 'secondary-btn' : 'primary-btn', brandButtonClass]" class="btn-2" href="#">Calculate Payments</a>
      </div>
      <div class="col-sm-3">
        <a :class="[usingFlatButton || brand === 'cjdr' ? 'secondary-btn' : 'primary-btn', brandButtonClass]" class="btn-3" href="#">Notify Me If Price Drops</a>
      </div>
      <div class="col-sm-3">
        <a :class="[usingFlatButton || brand === 'cjdr' ? 'secondary-btn' : 'primary-btn', brandButtonClass]" class="btn-4" href="#">Get Pre-Approved</a>
      </div>
    </div>
  </div>
</template>

<script>
import RowVehiclePricing from './RowVehiclePricing.vue'

export default {
  name: "RowVehicle",
  data() {
    return {
      hovering: false
    }
  },
  props: {
    vehicle: {
      type: Object,
      required: true,
    },
    price: {
      type: Object,
      required: true,
    },
    priceBtnTitle: {
      type: String,
      required: true,
    },
    selectedPriceBtn: {
      type: [Object, null],
      required: false,
    },
    isLockedPricingSelected: {
      type: Boolean,
      required: true,
    },
    brandColors: {
      type: Object,
      required: true,
    },
    brand: {
      type: String,
      required: true
    }
  },
  computed: {
    selectedPriceBtnImg() {
      return this.selectedPriceBtn.image;
    },
    selectedPriceBtnHoverImg() {
      if (this.selectedPriceBtn.hovered_image) {
        return this.selectedPriceBtn.hovered_image;
      } else {
        return this.selectedPriceBtn.image;
      }
    },
    usingFlatButton() {
      if (this.priceBtnTitle === 'Brand Specific HTML Button') {
        return true;
      } else {
        return false;
      }
    },
    flatButtonText() {
      if (this.isLockedPricingSelected) {
        return 'Click To Unlock Price';
      } else {
        return 'Click To Lock In Your EPrice';
      }
    },
    brandButtonClass() {
      if (this.brand.toLowerCase() !== 'none') {
        return this.brand.toLowerCase() + '-btn';
      } else {
        return 'default-btn';
      }
    }
  },
  methods: {
  },
  components: {
    RowVehiclePricing,
  }
};
</script>

<style
  scoped
  src="../../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>

.vehicle-unit {
  background: #fff;
  padding: 10px 0px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  margin: 0 0 10px 0;
}

.srp-window-sticker-link i {
  font-size: 20px;
  color: green;
}

.srp-window-sticker-link span {
  font-weight: 400;
}

.vehicle-index-summary {
  padding-bottom: 10px;
  padding-top: 10px;
}

.vehicle-index-page {
  background: #f0f0f0;
}

.vehicle-index-container {
  max-width: 1440px;
  margin: auto;
}

.listing-page {
  padding-top: 15px;
  margin: 0 auto;
}

.vdp-link {
  font-weight: 300;
  font-size: 14px;
  color: #5b616b;
}

.vehicle-thumb img {
  width: 100%;
}

.vehicle-index-summary .pull-right {
  font-weight: 300;
}

.stacked-srp-prices h3,
.stacked-srp-prices h4 {
  margin: 0 0 5px;
}

.stacked-srp-prices h5 {
  margin: 0 0 10px;
  font-size: 12px;
}

.stacked-srp-prices .vauto-incentives h4 {
  font-size: 16px;
}

.stacked-srp-prices .single-stacked-price {
  margin-top: 37px;
}

.stacked-srp-prices .double-stacked-price {
  margin-top: 15px;
}

.stacked-srp-prices .price-savings {
  color: green;
}
.stacked-srp-prices .price-savings h5 {
  padding-bottom: 5px;
  border-bottom: 1px solid;
}

.stacked-srp-prices .price-total-savings {
  color: green;
}
.stacked-srp-prices .price-total-savings h4 {
  font-size: 1.7em;
}
.stacked-srp-prices .price-total-savings h5 {
  padding-bottom: 5px;
  border-bottom: none;
}

.vehicle-specs {
  font-size: 14px;
  font-weight: bold;
}
.vehicle-specs h2 {
  font-size: 20px;
  padding-bottom: 10px;
}

.sticky-bottom-content {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
  padding: 10px;
  z-index: 99;
  border-top: 1px solid black;
}

.text-toggle {
  display: inline-block;
  background-color: #a5a5a5;
  color: white;
  padding: 3px 5px;
  border-radius: 5px;
}
.text-toggle:hover {
  cursor: pointer;
}

@media only screen and (min-width: 768px) {
  .vehicle-index-price {
    padding-top: 90px;
  }
  .index-button-padding {
    padding: 0;
  }
}

@media only screen and (max-width: 768px) {
  .vehicle-unit {
    padding-bottom: 10px;
  }
  .car-srch-box {
    padding-left: 30px;
    padding-right: 30px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 992px) {
  .spects .bottom_link a {
    padding: 10px;
    font-size: 14px;
  }
  .page-filter .glyphicon-th-list {
    margin-right: 10px;
  }
  .filter-form {
    padding-right: 0;
  }
}

@media only screen and (max-width: 768px) {
  .index-button-left {
    padding-right: 0;
  }
  .index-button-right {
    padding-left: 0;
  }
  .search-list .vehicle-index-price {
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .search-list .vehicle-index-price h3 {
    font-size: 15px;
  }
  .right-button-cont {
    padding: 25px 0 0 0;
  }
  .filter-form {
    padding-right: 0;
  }
  .spects .bottom_link a {
    margin-bottom: 10px;
  }
  .small_p {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .col-sm-4.car-box {
    margin-bottom: 20px;
    background: #fff;
  }
  .filter-form {
    padding-right: 0;
  }
  .Banner .item img {
    min-height: auto !important;
  }
  .FooterBlack .left_footer_text {
    text-align: center;
    width: 100%;
    display: inline-block;
  }
  .FeaturedCarData {
    text-align: center;
  }
}

@media only screen and (max-width: 1024px) {
  .available-rebates-btn {
    font-size: 12px;
  }
}

.get-price-button,
.unlock-price-button {
  width: 100px;
  max-width: 100%;
  cursor: pointer;
}

.vehicle-filter-home-buttons .btn {
  width: 100%;
  color: #d92027;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 0;
  font: 600 20px/30px "Open Sans", sans-serif;
  text-transform: none;
  text-indent: 0;
  border: 2px solid #d92027;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  opacity: 1;
  margin-bottom: 10px;
}
.vehicle-filter-home-buttons .btn:hover {
  background: rgba(217, 32, 39, 0.8);
  color: #fff;
  border: 2px solid #fff;
}
.vehicle-buttons {
  padding-top: 10px;
  text-align: center;
  margin: 0 auto;
}
.vehicle-buttons a, .get-price-btn-wrapper a {
  display: block;
  width: 100%;
  margin: 5px auto;
  -webkit-transition: .3s all ease;
  -moz-transition: all 0.3s ease;
  -o-transition: .3s all ease;
  transition: .3s all ease;
}
.pricing-wrapper {
  padding: 5px 25px 0 25px;
}
.get-price-btn-wrapper {
  width: 100%;
  text-align: center;
}
.get-price-btn {
  max-height: 140px;
  cursor: pointer;
  max-width: 100%;
}
.get-price-flat-btn {
  margin-top: 15px !important;
}

</style>